<nz-layout style="height: 100%" *ngIf="!isLoading && userIdentity !== undefined"
  [ngClass]="{ 'layout-with-header-collapsed': headerCollapsed }">
  <ng-container *ngIf="header != undefined" [ngTemplateOutlet]="header"></ng-container>

  <div [ngClass]="{
      'collapsible-header': collapsibleHeader,
      'header-collapsed': headerCollapsed
    }">
    <nz-header *ngIf="header === undefined" class="top-page">
      <nz-divider class="s-h xs-h m-h" nzType="vertical"></nz-divider>
      <div class="menu-slider xl-h l-h">
        <button nz-button nzGhost (click)="toggleSideMenu()" class="menu-toggle">
          <i nz-icon nzType="menu"></i>
        </button>
      </div>
      <div *ngIf="userIdentity !== undefined" class="logo" [routerLink]="[app.baseUrl]">
        <img *ngIf="userIdentity.Area === 1" [src]="'assets/apps/' + app.id + '/logo.svg'"
          [style]="'float: left;' + (app.id == 'itm-helpdesk' ? 'height: 35px !important;' : '')" />
        <img *ngIf="userIdentity.Area === 2"
          [src]="global.getLogoUrl()  ? global.getLogoUrl() :(baseUrl + 'Account/LogoCP.html?db=' + userIdentity.CompanyDB | safeHtml: 'url')"
          style="float: left" />
        <img *ngIf="userIdentity.Area === 3"
          [src]="global.getLogoUrl()  ? global.getLogoUrl()  : (baseUrl + 'Account/LogoSP.html' | safeHtml: 'url')"
          style="float: left" />
        <span *ngIf="userIdentity.Area === 1" class="l-h xl-h m-h" style="
            color: #fff;
            font-size: 24px;
            float: left;
            margin-top: -15px;
            margin-left: 5px;
          ">
          {{ "Home" | locale }}
        </span>
      </div>
      <div class="search-box" *ngIf="userIdentity.Area === -1">
        <nz-input-group nzSearch nzSize="default" [nzSuffix]="suffixIconSearch">
          <input type="text" nz-input [placeholder]="'Search' | locale" />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>
      </div>
      <div class="app-name s-h xs-h" *ngIf="userIdentity.Area === 1">
        <a [routerLink]="[app.baseUrl]">
          <img [src]="'assets/apps/' + app.id + '/name.svg'" />
        </a>
      </div>
      <ng-container *ngIf="userIdentity.Area === 1">
        <div class="company-switcher-block s-h xs-h m-h">
          <app-application-company-switcher [userIdentity]="userIdentity"></app-application-company-switcher>
        </div>
      </ng-container>
      <div class="user-name-block">
        <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="switchUserMenu"
          style="color: white;margin-top: 10px;display: block;float: left;" *ngIf="
            companyUsers.length > 1 || (searchUser != null && searchUser != '')
          ">
          {{ "Switch user" | locale }}
        </a>
        <nz-dropdown-menu #switchUserMenu="nzDropdownMenu">
          <input nz-input nzSize="small" [(ngModel)]="searchUser" (ngModelChange)="searchUserChange()"
            placeholder="{{ 'Search' | locale }}" />
          <ul nz-menu nzSelectable style="max-height: 300px; overflow-y: scroll">
            <li nz-menu-item *ngFor="let user of companyUsers" (click)="changeContactCompany(user)" [nzSelected]="
                user.CntctCode == userIdentity.ContactCode &&
                user.CompanyDB === userIdentity.CompanyDB
              ">
              <i class="fal fa-building"></i>&nbsp;{{ user.CardName }} <br />
              <i class="fal fa-user-tie"></i>&nbsp;{{ user.CntctName }}<br />
              <i class="fal fa-company"></i>&nbsp;{{ user.CompanyDBName }}
            </li>
          </ul>
        </nz-dropdown-menu>
        <div class="user-name s-h xs-h m-h" nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomRight"
          nzTrigger="click">
          <span *ngIf="userIdentity.Area === 1">
            {{ userIdentity.UserFullName }}
          </span>
          <span *ngIf="userIdentity.Area !== 1">
            <nz-space>
              <nz-space-item style="margin: 6px;">
                <i class="fal fa-building" style="font-size: 29px; margin-top: 5px"></i>
              </nz-space-item>
              <nz-space-item style="margin-right: 8px;">
                <p style="height: 6px; font-weight: bold">
                  {{ userIdentity.CardName }}
                </p>
                <span style="font-size: 12px">{{
                  userIdentity.ContactName
                  }}</span>
              </nz-space-item>
            </nz-space>
          </span>
        </div>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li *ngIf="userIdentity.Area !== 1" nz-menu-item [routerLink]="
                '/apps/external-portal/app-container/' + appId + '/profile'
              ">
              <i class="fal fa-id-card"></i>&nbsp;{{ "Profile" | locale }}
            </li>
            <li nz-menu-item *ngIf="userIdentity.Area === 1" (click)="authOffice365()">
              <i nz-icon nzType="mail" nzTheme="outline"></i> {{ 'Connect Office365' | locale }}
            </li>
            <li nz-menu-item (click)="logout()">
              <i nz-icon nzType="logout" nzTheme="outline"></i>{{ "Logout" | locale }}
            </li>
          </ul>
        </nz-dropdown-menu>
        <!-- <div class="notification-area" style="float: right; margin-right: 25px; margin-top: 3px"
          *ngIf="userIdentity.Area == 2">
          <button nz-button nzType="primary" nzShape="circle" (click)="openShoppingCart()">
            <nz-badge [nzCount]="totals.quantity" class="inboxIconBadge">
              <i nz-icon nzType="fa-light fa-cart-shopping" nzTheme="fill" class="ingoxIcon"></i>
            </nz-badge>
          </button>
        </div> -->
      </div>
      <div class="apps-logo-mobile" *ngIf="userIdentity.Area === 1">
        <a [routerLink]="[appsUrl]">
          <span></span>
        </a>
      </div>
      <div class="notification-area" style="float: right; margin-right: 25px; margin-top: 3px"
        *ngIf="userIdentity.Area == 1 && showAlertBell">
        <button nz-button nzType="primary" nzShape="circle" (click)="openNotificationDrawer()">
          <nz-badge [nzCount]="unreadmessagesCount" class="inboxIconBadge">
            <i nz-icon nzType="bell" nzTheme="fill" class="ingoxIcon"></i>
          </nz-badge>
        </button>

        <!-- <app-bell></app-bell> -->
      </div>
    </nz-header>
    <div class="sub-header" *ngIf="screenSize === 'large' || screenSize === 'x-large'">
      <div class="sub-header-menu">
        <app-menu [app]="app"></app-menu>
        <div *ngIf="headerHtml" class="header-html-content" [innerHTML]="headerHtml | safeHtml"></div>
      </div>
    </div>
    <div class="collapsed-header"></div>
    <div class="collapse-button" (click)="changeHeaderCollapsed()">
      <i class="fal fa-thumbtack" [ngClass]="{ rotated: headerCollapsed }"></i>
    </div>
  </div>
  <nz-layout>
    <nz-drawer [nzTitle]="app.name" *ngIf="!(screenSize === 'large' || screenSize === 'x-large')"
      [nzVisible]="!isCollapsed" (nzOnClose)="isCollapsed = true" [nzPlacement]="'left'"
      nzWrapClassName="sider-drawer drawer-size-3x">
      <app-menu [app]="app" [direction]="'vertical'" (menuSelected)="menuSelected()"></app-menu>
      <nz-divider></nz-divider>
      <ul nz-menu [nzMode]="'vertical'">
        <li nz-menu-item>
          <i nz-icon nzType="logout" nzTheme="outline"></i>
          <a (click)="logout()"> {{ "Logout" | locale }}</a>
        </li>
      </ul>
    </nz-drawer>
    <nz-affix>
      <app-page-header></app-page-header>
    </nz-affix>
    <nz-content [class]="'apps-container-page ' + containerAdditionalClass"
      [ngClass]="{ 'transparent-bg': containerTranspareBG }">
      <router-outlet></router-outlet>
    </nz-content>
    <nz-footer [ngStyle]="{ 'padding-left': footerLeftPadding + '%' }" [class]="footerAdditionalClass">
      <nz-divider style="margin: 8px 0"></nz-divider>
      <div class="l-h xl-h m-h s-h">
        <div style="float: left">
          {{ userIdentity.CompanyName }} ({{ userIdentity.CompanyDB }})
        </div>
        <div style="float: right">
          <app-languages-list></app-languages-list>
        </div>
      </div>
      <div class="xs-h">
        <div class="footer-left">
          <span>{{ userIdentity.CompanyName }}
            <span class="company-db-name">({{ userIdentity.CompanyDB}})</span>
          </span>

          <span>
            <nz-divider nzType="vertical"></nz-divider>
            {{ app.name | locale }}
          </span>
        </div>
        <div *ngIf="!global.hideITMFromFooter" class="footer-right copy-right">
          BWEB © 2011-{{nowYear}}
          <nz-divider nzType="vertical"></nz-divider>
          ITM Development Sàrl
          <nz-divider nzType="vertical"></nz-divider>
          <app-languages-list></app-languages-list>
        </div>
      </div>
    </nz-footer>
  </nz-layout>
</nz-layout>

<!-- Notification Drawer Template -->
<ng-template #notificationDrawer let-data let-drawerRef="drawerRef">
  <nz-tabset>
    <nz-tab [nzTitle]="alertTemplate">
      <ng-template #alertTemplate>
        <i nz-icon nzType="message" nzTheme="fill"></i>
        Alerts
      </ng-template>
      <ul nz-menu>
        <li nz-menu-item *ngFor="let unread of unreadMessages.data" class="messageInDrawer">
          <app-inboxMessage [message]="unread" (click)="openMessageDrawer(unread.Code)" [isDrawer]="true">
          </app-inboxMessage>
        </li>
      </ul>
    </nz-tab>
    <nz-tab [nzTitle]="activityTemplate">
      <ng-template #activityTemplate>
        <div (click)="openActivityTab()">
          <i nz-icon nzType="field-time" nzTheme="outline"></i>
          Activities
        </div>
      </ng-template>
      <nz-skeleton [nzLoading]="isActivitiesLoading" [nzActive]="true" [nzAvatar]="true">
        <nz-list>
          <nz-list-item *ngFor="let activity of activities" class="messageInDrawer">
            <nz-card style="height: 100%; width: 100%" (click)="openComponent(activity.ClgCode)">
              <nz-card-meta [nzAvatar]="avatarTemplate" [nzTitle]="activity.userName" [nzDescription]="
                  activity.Details ? activity.Details : 'No subject'
                "></nz-card-meta>
              <span class="activityTime">
                {{ activity.Recontact }}
                {{ activity.BeginTime | date: "shortTime" }}
              </span>
            </nz-card>
            <ng-template #avatarTemplate>
              <nz-avatar [nzSize]="45" [nzText]="activity.userName | fullNameShorter" class="activityAvatar">
              </nz-avatar>
            </ng-template>
          </nz-list-item>
        </nz-list>
      </nz-skeleton>
    </nz-tab>
  </nz-tabset>
</ng-template>


<ng-template #msAuthForm>
  <form nz-form>
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="email" nzRequired>Email</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <input nz-input id="email" [(ngModel)]="msAuthEmail" [ngModelOptions]="{ standalone: true }" placeholder="Enter your email" />
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-template>
